import axios from 'axios';

import IAnalyticsJobSearchFilterDTO from '../../../types/IAnalyticsJobSearchFilterDTO';
import { IPostgreJobsAnalyticsPayload } from '../../AnalyticsService';

const url = 'wsreporting/api/composable-analytics';
export const jobsPostedMetricCharts = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-metric-charts`, searchFilter);

export const jobsPostedBarChartsTime = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-bar-charts-time`, searchFilter);

export const jobsPostedBarChartsClients = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-bar-charts-clients`, searchFilter);

export const jobsPostedBarChartsClientContacts = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-bar-charts-client-contacts`, searchFilter);

export const jobsPostedTablesClient = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-tables-clients`, searchFilter);

export const jobsPostedTablesClientsContacts = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-tables-clients-contacts`, searchFilter);

export const jobsPostedStatusSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-status-split`, searchFilter);

export const jobsPostedStatusStackedBarChart = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-status-time-split`, searchFilter);

export const jobsPostedStatusClientsSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-client-status-split`, searchFilter);

export const jobsPostedStatusClientsSpocSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-client-spoc-status-split`, searchFilter);

export const jobsPostedClientAndClientSPOC = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-client-client-spoc`, searchFilter);

export const jobsPostedJobTypeSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-jobType-split`, searchFilter);

export const jobsPostedJobTypeStackedBarChart = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-jobType-time-split`, searchFilter);

export const jobsPostedJobTypeClientsSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-client-jobType-split`, searchFilter);

export const jobsPostedJobTypeClientsSpocSplit = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-client-spoc-jobType-split`, searchFilter);

export const jobsPostedAccountManager = (searchFilter: IAnalyticsJobSearchFilterDTO) =>
  axios.post(`${url}/jobs-posted-account-manager`, searchFilter);

const postgreAnalyticsUrl = '/analyticsreportingapp/api/composable-analytics';

export const getPostgreJobsAnalyticsData = (
  type: string,
  payload: IPostgreJobsAnalyticsPayload,
  abortController: AbortController
) => axios.post(`${postgreAnalyticsUrl}/jobs/${type}`, payload, abortController);
